import { createContext, useContext, useMemo, type ReactNode } from "react";

/**
 * Đường dẫn trang đang mở, phát từ khung ứng dụng xuống cho nút hướng dẫn.
 *
 * Vì sao không gọi thẳng `useLocation` trong nút: hook đó ĐÒI có Router bao
 * ngoài, mà `PageHeader` được dựng trần trong rất nhiều bài kiểm component
 * (không bài nào cần Router trước đây). Gọi thẳng là 163 bài kiểm đỏ cùng lúc
 * — hỏng thật, không phải hỏng ở bài kiểm.
 *
 * Context của mình thì thiếu nhà cung cấp chỉ trả về null, nút tự ẩn, không ai
 * nổ. Trong ứng dụng thật `AppShell` luôn bọc nên nút luôn có đường dẫn.
 */
type Loc = { pathname: string; tab: string | null };

const PageGuideLocation = createContext<Loc | null>(null);

export function PageGuideLocationProvider({
  pathname,
  tab,
  children,
}: {
  pathname: string;
  tab: string | null;
  children: ReactNode;
}) {
  const value = useMemo(() => ({ pathname, tab }), [pathname, tab]);
  return <PageGuideLocation.Provider value={value}>{children}</PageGuideLocation.Provider>;
}

/** Đường dẫn hiện tại, hoặc null khi dựng ngoài khung ứng dụng. */
export function usePageGuideLocation(): Loc | null {
  return useContext(PageGuideLocation);
}
